import React, { useEffect } from 'react';
import { AccessRequestsBarWidget } from '@sde/widgets-core/src/widgets/AccessRequestsBar';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { useProvider } from 'src/state/provider';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { usePendingRequestsQuery } from '@sde/widgets-core/src/common/hooks/usePendingRequests';

export const AccessRequestsBar = (props) => {
  const { user } = useUser.state();
  const { provider } = useProvider.state();
  const { onCompleted, onError } = props;
  const [userRequestsResult, getUserRequests] = usePendingRequestsQuery({
    onCompleted,
    onError,
  });
  const [thirdPartyRequestsResult, getThirPartyRequests] =
    usePendingRequestsQuery({
      onCompleted,
      onError,
    });

  const widgetProps = {
    data: {
      user,
      provider,
      userRequestsResult: isEmpty(userRequestsResult.data.requests)
        ? []
        : userRequestsResult.data.requests,
      thirdPartyRequestsResult: isEmpty(thirdPartyRequestsResult.data.requests)
        ? []
        : thirdPartyRequestsResult.data.requests,
      userRequestsResultLoading: userRequestsResult.loading,
      thirdPartyRequestsResultLoading: thirdPartyRequestsResult.loading,
    },
  };

  useEffect(() => {
    getUserRequests({ variables: { isThirdParty: false } });
    getThirPartyRequests({ variables: { isThirdParty: true } });
  }, []);

  return <AccessRequestsBarWidget {...widgetProps} />;
};

AccessRequestsBar.propTypes = {
  onCompleted: PropTypes.func,
  onError: PropTypes.func,
};

AccessRequestsBar.defaultProps = {
  onCompleted: () => null,
  onError: () => null,
};
